import React from 'react'
import { memo } from '~/ui/component'
import { HBox, Label, VBox } from '~/ui/components'
import { layout } from '~/ui/styling'

export interface Props {
  title:     string
  right?:    React.ReactNode
  children?: React.ReactNode
}

const HomeScreenWidget = memo('HomeScreenWidget', (props: Props) => {

  const {title, children, right} = props

  //------
  // Rendering

  function render() {
    return (
      <VBox gap={layout.padding.m}>
        <HBox gap={layout.padding.m} justify='space-between'>
          <Label h2>{title}</Label>
          {right}
        </HBox>
        {children}
      </VBox>
    )
  }

  return render()

})

export default HomeScreenWidget